export const ADDTOCART_POST_REQUEST = 'ADDTOCART_POST_REQUEST';
export const ADDTOCART_POST_ERROR = 'ADDTOCART_POST_ERROR';
export const ADDTOCART_POST_SUCCESS = 'ADDTOCART_POST_SUCCESS';
export const ADDTOCART_KEEPSHOPPING_ONCLICK = 'ADDTOCART_KEEPSHOPPING_ONCLICK';
export const ITEM_UPDATE_REQUEST = 'ITEM_UPDATE_REQUEST';
export const ITEM_UPDATE_SUCCESS = 'ITEM_UPDATE_SUCCESS';
export const ITEM_UPDATE_ERROR = 'ITEM_UPDATE_ERROR';
export const ADDTOCART_STICKY_ONCLICK = 'ADDTOCART_STICKY_ONCLICK';
export const ADDTOCART_ONCLICK = 'ADDTOCART_ONCLICK';
